<template>
	<footer id="footer">
		<div class="container">
			<div class="row">
				<div class="col-lg-5 col-xl-6 mb-3 mb-sm-0 col-logo" data-aos="fade" data-aos-offset="150">
					<p>
						<router-link to="/">
							<img src="public/images/logo-footer.svg" alt="unlawk">
						</router-link>
					</p>

					<h6 class="unlawk-title">2026 UNLAWK®</h6>
				</div>

				<div class="col-lg-7 col-xl-6 mb-lg-4 pl-lg-4 align-self-center col-text" data-aos="fade" data-aos-delay="150" data-aos-offset="150">
					<div class="row">
						<div class="col-sm-6 col-lg">
							<p>
								<router-link to="/directorio">
									Busco Solución Legal
								</router-link>
							</p>
							<p>
								<router-link to="/afiliacion">
									Soy Abogado
								</router-link>
							</p>
						</div>

						<div class="col-sm-6 col-lg">
							<p>
								<router-link to="/terminos-y-condiciones">
									Términos y Condiciones
								</router-link>
							</p>
							<p>
								<router-link to="/aviso-de-privacidad">
									Aviso de Privacidad
								</router-link>
							</p>
						</div>

						<div class="col-lg-3 col-social-networks">
							<p>
								<a class="link-social" href="">
									<i class="fa-sharp fa-regular fa-envelope"></i>
								</a>
								<a class="link-social" href="">
									<i class="fa-brands fa-linkedin-in"></i>
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script type="text/javascript">
	export default {
		mounted() {
		}
	}
</script>